import Post from '../api'
//菜单管理*****************
// 获取指定菜单
export const GetMenu = (param: object): any => {
    return Post('GetMenu', param)
}

// 获取所有菜单
export const AllMenu = (param: object): any => {
    return Post('AllMenu', param)
}
// 获取登录用户菜单
export const GetUserMenu = (param: object): any => {
    return Post('GetUserMenu', param)
}

// 保存菜单
export const SaveMenu = (param: object): any => {
    return Post('SaveMenu', param)
}

// 保存菜单的函数
export const SaveMenuFuns = (param: object): any => {
    return Post('SaveMenuFuns', param)
}
//读取中的方法
export const GetMenuFuns = (param: object): any => {
    return Post('GetMenuFuns', param)
}
// 删除菜单
export const DelMenu = (param: object): any => {
    return Post('DelMenu', param)
}

//白名单*************
export const UpdateWhiteList = (param: object): any => {
    return Post('UpdateWhiteList', param)
}
//操作日志*************
export const QueryOperateLog = (param: object): any => {
    return Post('QueryOperateLog', param)
}

//白名单*************
export const GetWhiteList = (param: object): any => {
    return Post('GetWhiteList', param)
}
//获取角色列表
export const GetRoleList = (param: object): any => {
    return Post('GetRoleList', param)
}
//保存角色
export const SaveRole = (param: object): any => {
    return Post('SaveRole', param)
}
//删除角色
export const DelRole = (param: object): any => {
    return Post('DelRole', param)
}
//读取角色
export const GetRoleInfo = (param: object): any => {
    return Post('GetRoleInfo', param)
}
//获取角色按钮
export const GetRoleButton = (param: object): any => {
    return Post('GetRoleButton', param)
}
//保存角色按钮
export const SaveRoleButton = (param: object): any => {
    return Post('SaveRoleButton', param)
}

//删除按钮
export const DelButton = (param: object): any => {
    return Post('DelButton', param)
}

//保存按钮
export const SaveButton = (param: object): any => {
    return Post('SaveButton', param)
}

// 管理员管理*******************

//添加/修改 管理员
export const SaveManager = (param: object): any => {
    return Post('SaveManager', param)
}
//删除管理员
export const DelManager = (param: object): any => {
    return Post('DelManager', param)
}

//管理员列表
export const GetManagerList = (param: object): any => {
    return Post('GetManagerList', param)
}
// ip地址查询
export const GetIpRegion = (param: object): any => {
    return Post('GetIpRegion', param)
}

//获取角色分类列表
export const GetRoleTypeList = (param: object): any => {
    return Post('GetRoleTypeList', param)
}

//保存角色分类数据
export const SaveRoleType = (param: object): any => {
    return Post('SaveRoleType', param)
}

//删除角色分类
export const DelRoleType = (param: object): any => {
    return Post('DelRoleType', param)
}
